import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncMenuPage = Load(
  () => import(/* webpackChunkName: "menupage" */ './containers/MenuPage'),
);
const AsyncHomePage = Load(
  () => import(/* webpackChunkName: "homepage" */ './HomePage'),
  {},
  true,
);
const AsyncHomeScreen = Load(
  () => import(/* webpackChunkName: "homescreen" */ './HomeScreen'),
  {},
  true,
);

const isApp = isCordova();

const HomescreenRoutes = [
  <NavigationableLayout
    key="more"
    path={`${basePath}/more`}
    hideFooter
    showZendesk={false}
    component={AsyncMenuPage}
    showBottomNavigation
    noNavbar
  />,
  <NavigationableLayout
    exact
    key="homepage"
    path={basePath}
    component={isApp ? AsyncHomeScreen : AsyncHomePage}
    showSearchInNavbar={false}
    showBottomNavigation
    transparentNavbar={!isApp}
    hideFooter={isApp}
    nonFixedNavbar={isApp}
  />,
];

export default HomescreenRoutes;
